import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import { i18n } from '../../utils/GadgetUtils';

console.log('check css modules in collapsible.*****************', styles);
const Collapsible = ({ children, width, containerCustomClass, contentCustomClass, customCollapsedClass, buttonClass, shortcutKeyConfig, displayOnHover }) => {
	const [collapsed, setCollapsed] = useState(false);
	const handleHandlerClick = async () => {
		setCollapsed(!collapsed);
	};

	useEffect(() => {
		// initialising shortcut key service
		window.finesse.shortcutkey.ShortcutKeyService.init();
		const shortCutKeyForCollapsible = [
			{
				'id': shortcutKeyConfig.shortcutKeyId,
				'componentName': shortcutKeyConfig.componentName,
				'actionName': shortcutKeyConfig.shortcutKeyAction,
				'modifierKeys': shortcutKeyConfig.modifierKeys,
				'key': shortcutKeyConfig.shortcutKey,
				handler: () => { 
					let updatedState;
					setCollapsed(currentState => { // Do not change the state by getting the updated state
						updatedState = currentState;
						return currentState;
					});
					setCollapsed(!updatedState);
				}
			}
		];
		window.finesse.shortcutkey.ShortcutKeyService.registerShortcutKey(shortCutKeyForCollapsible);
	}, []);

	return (
		<div
			className={`${styles['collapsible-container']} ${containerCustomClass} ${
				collapsed ?  `${styles.collapsed} ${customCollapsedClass}` : ''
			}`}
			style={{ maxWidth: width }}
		>
			<div className={`${styles.content} ${contentCustomClass}`} style={{ height: '100%' }}>{children}</div>
			<button className={`${styles.handler} ${buttonClass}`} style={{ display: `${displayOnHover && !collapsed ? "none" : "flex"}` }} onClick={handleHandlerClick} tabIndex="0" aria-label={i18n.getMsg('gadget.imi.operation.collapsible.arialabel')}>
				<md-icon name={collapsed ? 'icon-arrow-right-optical_8' : 'icon-arrow-left-optical_8'} />
			</button>
		</div>
	);
};

Collapsible.propTypes = {
	/* width is css style prop value with unit, ex: 100px or 80% or 10rem */
	width: PropTypes.string,
	/* containerCustomClass is css class we can pass to override/customise container's css */
	containerCustomClass: PropTypes.string,
	/* contentCustomClass is css class we can pass to override/customise content's css */
	contentCustomClass: PropTypes.string,
	/* children is the content we want to render inside collapsible-pane */
	children: PropTypes.any,
	displayOnHover: PropTypes.bool,
	shortcutKeyConfig: PropTypes.object
};

Collapsible.defaultProps = {
	displayOnHover: false
};

export default Collapsible;
